module.exports = __webpack_public_path__ + "static/media/list-view-light.199acbbe.svg";